// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607300053/js/" + chunkId + "." + {"44":"182cf381","225":"e14736fc","481":"cb3308d8","486":"fa3e660a","770":"6a8f15ab"}[chunkId] + ".0.9871765580846574.chunk.js";
};